<template>
    <div>
      <div class="content-header">
        <div class="content-header-left">
          <div class="search">
            <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" v-model="searchtxt" placeholder="Search by Name/Type"
              class="is-label-placeholder" />
          </div>
        </div>
        <div class="content-header-right">
          <vs-button type="border"  class="light-blue-btn"  @click="createTemplate(false)" v-if="[1,2,3].indexOf(getUserRoleId)>-1">
              Add 
           <span>
            <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
          </span>
        </vs-button>
        </div>
      </div>
    <NoDataFound ref="NoDataFoundRef" :loading="isListLoading" v-if="list.length == 0" heading="No Results Found" type='branches' />
      <div class="accordian-table" v-if="list.length>0">
        <vs-table :data="list" >
          <template slot="thead" >
           <vs-th>
            <a @click="sortMe('name')"  v-bind:class="{'sort_ascending':sortKeys['name']==1, 'sort_descending':sortKeys['name']!=1}" >
               Name
                </a>
            </vs-th> 
            <vs-th>
            <a @click="sortMe('tplType')"  v-bind:class="{'sort_ascending':sortKeys['tplType']==1, 'sort_descending':sortKeys['tplType']!=1}" >
             Type
             </a>
            </vs-th>
            <vs-th>
            <a>
              No of Work Locations
            </a>
            </vs-th>
            <vs-th>
            <a>
               Document
            </a>
            </vs-th>
            <vs-th class="actions">Actions</vs-th>
          </template>
          <!--  -->
          <template slot-scope="{data}">
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.username">
                <a class="cursor-pointer"> <span> {{tr.name }}  </span> </a>
              </vs-td>
              <vs-td >{{tr.tplTypeName  }}</vs-td >
                <vs-td >{{tr.noOfWorkLocations  }}</vs-td >
                <vs-td >
                  <template v-if="tr.prepareTemplateId">
                    <img @click="openTempPreview(tr)" class="cursor-pointer" src="@/assets/images/documentImage.svg"/> 
                  </template>
                  
                </vs-td>
              <vs-td >
                <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                    <a class="a-icon" href.prevent><more-vertical-icon size="1.5x" class="custom-class"></more-vertical-icon></a>
                   <vs-dropdown-menu class="loginx msg_dropdown">
                      <vs-dropdown-item @click="createTemplate(tr,true)">
                        <template>
                        <a> <span>Edit</span></a>
                        </template>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="showDeleteModal(tr)">
                        <template>
                        <a><span>Delete</span></a>
                        </template>
                      </vs-dropdown-item>
                     </vs-dropdown-menu>
                  </vs-dropdown>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="table_footer">
          <div class="vx-col  con-select pages_select"  v-if="list.length>0">
            <label class="typo__label">Per Page</label>
            <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
                :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
                :preselect-first="true">
              </multiselect>
              <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
            </div>
            <paginate  v-if="list.length>0"  v-model="page" :page-count="totalpages" :page-range="3" :margin-pages="2" :click-handler="pageNate"
          prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
          next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
          :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'"></paginate>
        </div>
        
      </div>
      <addOrEditSignDocs v-if="showCreate" :callFromEdit="callFromEdit"  :editItem ="selectedItem" @hideMe="hideMe"/>
    <modal name="conformArchivemodal" classes="v-modal-sec" :min-width="200" :min-height="200" :scrollable="true"
      :reset="true" width="450px" height="auto">
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">
            Delete
          </h2>
          <span @click="$modal.hide('conformArchivemodal');formerrors.msg=''">
            <em class="material-icons">close</em>
          </span>
        </div>
        <div class="form-container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <p class="msg_text">Are you sure to continue?</p>
            </div>
          </div>
          <div v-show="formerrors.msg">
            <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
              icon="IP-information-button" active="true">{{ formerrors.msg }}</vs-alert>
          </div>
        </div>
        <div class="popup-footer relative">
          <figure v-if="archiving" class="loader"><img src="@/assets/images/main/loader.gif" /></figure>
          <vs-button color="dark" class="cancel" type="filled" @click="$modal.hide('conformArchivemodal');formerrors.msg=''">No
          </vs-button>
          <vs-button :disabled="archiving" color="success" class="save" type="filled" @click="deleteSelectedItem()">Yes
          </vs-button>
        </div>
      </div>
    </modal>
    <iframePafTemplate v-if="showPreviewTemplate" :templateUrl="selectedPreviewUrl" />
    </div>
  </template>
  <script>
  import iframePafTemplate from "@/views/globalSettings/iframePafTemplate.vue";
  import DateRangePicker from "vue2-daterange-picker";
  import Datepicker from "vuejs-datepicker-inv";
  import Paginate from "vuejs-paginate";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  import _ from "lodash";
  import { FormWizard, TabContent } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import moment from 'moment'
  import JQuery from 'jquery'
  import { TheMask } from 'vue-the-mask'
  import NoDataFound from "@/views/common/noData.vue";
  import FileUpload from "vue-upload-component/src";
  import VuePhoneNumberInput from 'vue-phone-number-input';
  import 'vue-phone-number-input/dist/vue-phone-number-input.css';
  import { MoreVerticalIcon } from 'vue-feather-icons'
  import addOrEditSignDocs from "./addOrEditSignDocs.vue";
    export default {
       
      computed:{
      },
      components: {
        iframePafTemplate,
        addOrEditSignDocs,
        DateRangePicker,
        VuePhoneNumberInput,
        MoreVerticalIcon,
        Datepicker,
        Paginate,
        FileUpload,
        FormWizard,
        TabContent,
        TheMask,
        NoDataFound,
      },
  
      data: () => ({ 
        selectedPreviewItem:null,
        showPreviewTemplate:false,
        selectedPreviewUrl:'',
        selectedItem:null,
        callFromEdit:null,
        showCreate:false,
        templateId:null,
        formerrors: {
          msg: ""
        },
        archiving:false,
        isListLoading:false,
        callFromSerch:false,
        list: [],
        searchtxt: "",
        page: 1,
        perPeges: [10,25,50,75,100],
        perpage: 25,
        totalCount:0,
        totalpages: 0,
        sortKeys:{},
        sortKey:{},
        
      }),
      watch: {
        searchtxt: function (value) {
          this.getList(true);
        }
  
      },
      methods: {
        openTempPreview(item = null){
          this.showPreviewTemplate = false;
          this.selectedPreviewItem = item;
          this.selectedPreviewUrl =  '';
          if(this.selectedPreviewItem && this.checkProperty(this.selectedPreviewItem, 'prepareTemplateId')){
            let payLoad = {
              type:this.checkProperty(this.selectedPreviewItem, 'tplType'),
              editing:false,
              templateId:this.checkProperty(this.selectedPreviewItem, 'prepareTemplateId')
            };
            let path = '/pdf-sign/get-tpl-prepare-iframe-url'
            this.$store.dispatch("commonAction", {data:payLoad, path:path}).then((res)=>{
              let resp = res;
              if(this.checkProperty(resp, 'url')){
                this.selectedPreviewUrl = resp['url'];
                this.showPreviewTemplate = true;
              }
            }).catch((err)=>{

            })
          }
        },
        deleteSelectedItem(){
            this.formerrors.msg =''
            let postData ={
              "templateId": this.templateId
            };
            this.archiving =true;
              this.$store
              .dispatch("commonAction", {"data":postData ,"path":"/pdf-sign/delete-esign-template"})
              .then(response => {
               
                this.archiving =false;
                this.templateId = null;
                this.showToster({message:response.message,isError:false });
                this.getList();
                this.$modal.hide('conformArchivemodal')            
              })
              .catch((error)=>{
                this.formerrors.msg =error
                this.archiving =false;
              })

        },
        showDeleteModal(item){
               this.templateId=null
                if(item&&item._id){
                  this.templateId = item._id;
                  this.$modal.show('conformArchivemodal');
                }
        },
        createTemplate(item = null,callFromedit = false){
                this.callFromEdit = callFromedit;
                if(item && this.callFromEdit){
                    this.selectedItem = item;
                }
                this.showCreate= true;
            },
            hideMe(){
                this.callFromEdit = false;
                this.selectedItem = null;
                this.showCreate = false;
                this.getList();
            },
        sortMe(sort_key=''){
          if(sort_key !=''){
              this.sortKeys[sort_key] = this.sortKeys[sort_key]==1?-1:1
              this.sortKey = {"path":sort_key ,"order":this.sortKeys[sort_key]};
              this.getList();
          }
        },
        changeperPage(){
          this.page = 1;
          this.getList(true);
        },
        getList(callFromSerch=false) {
          this.callFromSerch = callFromSerch;
           if(this.callFromSerch){
            this.list =[];
          }
           let item ={
            filters:{
              "title":this.searchtxt.trim(),
            }, 
            page:this.page,
            perpage: this.perpage,
            sorting:this.sortKey,  
          };
          this.updateLoading(true);
          this.isListLoading =true;
          this.$store
            .dispatch("getList",{"data":item ,"path":"/pdf-sign/esign-template-list"})
            .then(response => {
              this.list = response.list;
        //      this.list = [
        //     {
        //         "_id": "6662b34d28dc8520e4fd5876",
        //         "status": true,
        //         "name": "LCA Acknowledgement",
        //         "prepareTemplateId": "665491c2f7c8af4bc8277546",
        //         "tplType": "LCA_ACK",
        //         "tplCode": "LCA_ACK",
        //         "createdBy": "623866f0ed24493a148c046e",
        //         "createdByName": "Admin User QQ",
        //         "createdByRoleId": 3,
        //         "createdByRoleName": "Admin",
        //         "createdOn": "2024-06-07T07:14:21.949Z",
        //         "updatedOn": "2024-06-07T07:14:21.950Z",
        //         "__v": 0
        //     },
        //     {
        //         "_id": "6662b34d28dc8520e4fd5876",
        //         "status": true,
        //         "name": "LCA Acknowledgement",
        //         "prepareTemplateId": "665491c2f7c8af4bc8277546",
        //         "tplType": "LCA_ACK",
        //         "tplCode": "LCA_ACK",
        //         "createdBy": "623866f0ed24493a148c046e",
        //         "createdByName": "Admin User QQ",
        //         "createdByRoleId": 3,
        //         "createdByRoleName": "Admin",
        //         "createdOn": "2024-06-07T07:14:21.949Z",
        //         "updatedOn": "2024-06-07T07:14:21.950Z",
        //         "__v": 0
        //     }
        // ]
              this.totalCount = this.checkProperty(response, 'totalCount');
              this.totalpages = Math.ceil(response.totalCount / this.perpage);
              this.isListLoading =false;
              this.updateLoading(false);
            }).catch((error)=>{
                 this.isListLoading =false;
                this.updateLoading(false);
            })
        },
        pageNate(pageNum) {
          this.page = pageNum;
          this.getList();
        },
      },
      mounted() {
        this.sortKeys = { "createdOn":-1, "createdByName":1, "managerName":1, "name":1, "active":1, "updatedOn":1,'tplType':1  },
        this.getList();
      }
    };
  </script>
  